<template>
	<div class="version-page">
		<div class="card-header">版本信息</div>
		<section class="card-node overview-section">
			<div class="status-grid">
				<div class="status-item">
					<p class="label">
						{{ currentSubscribe ? currentSubscribe.name : 'Free版' }}
					</p>
					<div class="value-row">
						<span class="price">
							${{ currentSubscribe ? currentSubscribe.price : '0.00' }}
						</span>
						<small>/ 月</small>
						<el-link type="primary" class="ml-10">详情</el-link>
						<el-link v-if="currentSubscribe && currentSubscribe.is_expired !== 1" type="primary"
							class="ml-10 renew-link" :underline="false" @click="openUpgradeDialog">
							续订
						</el-link>
					</div>
					<el-dialog title="更改套餐" :visible.sync="upgradeVisible" width="900px" append-to-body>
						<div class="upgrade-container">
							<div class="upgrade-config">
								<div class="config-section">
									<h4 class="section-title">选择套餐版本</h4>
									<div class="version-selector">
										<div v-for="item in plansList" :key="item.id" class="version-card"
											:class="{ active: selectedPlan.id === item.id }" @click="selectPlan(item)">
											<div class="name">{{ item.name }}</div>
											<div class="price">${{ item.price }} / {{ item.period_name }}</div>
										</div>
									</div>
								</div>

								<div class="config-section">
									<h4 class="section-title">成员数</h4>
									<div class="seat-stepper">
										<el-input-number v-model="currentSeats" :min="selectedPlan.seats || 1"
											size="medium"></el-input-number>
										<span v-if="addedSeats > 0" class="ml-10" style="color: #E6A23C;">
											新增 {{ addedSeats }} 个
										</span>
									</div>
								</div>

								<div class="config-section">
									<h4 class="section-title">支付方式</h4>
									<el-checkbox v-model="useBalance" disabled checked>余额抵扣</el-checkbox>
								</div>
							</div>

							<div class="upgrade-summary">
								<h4 class="summary-title">购买后套餐</h4>
								<div class="summary-item">
									<span>套餐版本</span>
									<span>{{ selectedPlan.name }}</span>
								</div>
								<h4 class="summary-title">套餐金额</h4>
								<div class="summary-detail-box">
									<div class="summary-item">
										<span>版本费用</span>
										<span>${{ selectedPlan.price }} / {{ selectedPlan.period_name }}</span>
									</div>

									<div class="summary-item">
										<span>
											{{ selectedPlan.seats }}
											<span v-if="addedSeats > 0" style="color: #409EFF;">+
												{{ addedSeats }}</span>
											个成员
										</span>
										<span>${{ addedSeatsCost }} / {{ selectedPlan.period_name }}</span>
									</div>


								</div>
								<div class="summary-item">
									<span>截止日期</span>
									<span style="color: #409EFF; font-weight: bold;">{{ newDeadline }}</span>
								</div>
								<h4 class="summary-title" style="margin-top: 20px;">订单金额</h4>
								<div class="summary-item">
									<span>金额</span>
									<span>${{ packageTotal }}</span>
								</div>
								<div class="summary-item">
									<span>折扣</span>
									<span style="color: #67C23A;">
										{{ currentDiscountRate === 100 ? '无折扣' : (currentDiscountRate + '%') }}
									</span>
								</div>

								<div class="summary-item total-row">
									<span>需支付</span>
									<span class="final-price">${{ finalPayPrice }}</span>
								</div>
								<el-button type="primary" class="submit-btn" @click="submitUpgrade">提交订单</el-button>
							</div>
						</div>
					</el-dialog>
				</div>
				<div class="status-item">
					<p class="label">截止日期</p>
					<div class="value-row">
						<span class="value">
							<template v-if="!currentSubscribe">
								无限期
							</template>
							<template v-else>
								<span v-if="currentSubscribe.is_expired === 1" style="color: #f56c6c;">已过期</span>
								<span v-else>{{ currentSubscribe.end_time }}</span>
							</template>
						</span>
					</div>
				</div>
				<div class="status-item">
					<p class="label">钱包余额</p>
					<div class="value-row">
						<span class="price">${{ walletMoney }}</span>
						<el-link type="primary" class="ml-10">详情</el-link>
						<el-button type="primary" size="small" class="ml-20" @click="handleRecharge">充值</el-button>
					</div>
				</div>
				<el-dialog title="钱包充值" :visible.sync="rechargeVisible" width="450px" append-to-body>
					<el-form :model="rechargeForm" label-width="100px" size="medium">
						<el-form-item label="充值金额">
							<el-input v-model="rechargeForm.amount" placeholder="请输入需要储值的金额" type="number">
								<template slot="prepend">$</template>
							</el-input>
						</el-form-item>
						<!-- <el-form-item label="支付凭证" class="proof-form-item">
							<el-upload class="proof-uploader" action="#" list-type="picture-card" :auto-upload="false"
								:show-file-list="false" :on-change="handleFileChange" :on-success="handleUploadSuccess">

								<img v-if="rechargeForm.proof" :src="rechargeForm.proof" class="avatar">
								<i v-else class="el-icon-plus"></i>
							</el-upload>
							<div class="el-upload__tip proof-tip">请上传转账成功截图</div>
						</el-form-item> -->


						<el-form-item label="支付金额" class="recharge-form-item">
							<div class="pay-amount-value">
								${{ rechargeForm.amount || '0.00' }}
							</div>

							<div v-if="rechargeDesc" class="recharge-desc-content" v-html="rechargeDesc"></div>
						</el-form-item>
					</el-form>

					<div slot="footer" class="dialog-footer">
						<el-button @click="rechargeVisible = false">取 消</el-button>
						<el-button type="primary" @click="submitRecharge"
							:disabled="!rechargeForm.amount">提交支付</el-button>
					</div>
				</el-dialog>
			</div>
		</section>

		<section class="plan-section" v-if="!currentSubscribe || currentSubscribe.is_expired === 1">
			<div class="card-header">选择符合您的套餐</div>
			<div class="plan-grid">
				<div v-for="(plan, index) in plans" :key="index" class="plan-card" :class="plan.type">
					<div v-if="plan.discount" class="discount-tag">{{ plan.discount }}</div>

					<div class="plan-content">
						<div class="plan-header">
							<h4 class="name">{{ plan.name }}</h4>
							<div class="price-box">
								<span class="unit">$</span>
								<span class="amount">{{ plan.price }}</span>
								<span class="cycle">/{{ plan.periodName || '月' }}{{ plan.suffix || '' }}</span>
							</div>
							<p class="desc">{{ plan.desc }}</p>
						</div>

						<el-button :type="plan.buttonType" :plain="plan.isCurrent" class="plan-btn"
							@click="handleUpgradeClick(plan)">
							{{ plan.buttonText }}
						</el-button>

						<ul class="feature-list">
							<li v-for="(feature, fIdx) in plan.features" :key="fIdx">
								<i class="el-icon-success"></i> {{ feature }}
							</li>
						</ul>

						<div v-if="plan.logos" class="client-logos">
							<p>全球 300,000+ 客户选择</p>
							<div class="logo-wall">
								<div v-for="n in 6" :key="n" class="logo-placeholder"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<div class="card-header">订单明细</div>

		<section class="card-node order-section">
			<div class=" flex-between">
				<div class="filter-box">
					<div>
						<span class="filter-label">建立日期：</span>
						<el-date-picker v-model="dateRange" type="daterange" size="small" range-separator="-"
							start-placeholder="开始" end-placeholder="结束" value-format="yyyyMMdd" />
					</div>
					<div class="pagination-container">
						<el-pagination :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper" :total="total"
							@size-change="handleSizeChange" @current-change="handleCurrentChange" />
					</div>
				</div>
			</div>

			<div class="table-wrapper">
				<el-table :data="tableData" style="width: 100%" size="medium">
					<el-table-column prop="order_sn" label="订单编号" min-width="180" />

					<el-table-column prop="status_text" label="订单状态" width="120">
						<template slot-scope="{row}">
							<span :class="['status-tag', row.status === '0' ? 'status-pending' : '']">
								{{ row.status_text }}
							</span>
						</template>
					</el-table-column>

					<el-table-column prop="createtime_text" label="建立日期" width="160" sortable />

					<el-table-column prop="starttime_text" label="支付日期" width="160" sortable>
						<template slot-scope="{row}">
							<span>{{ row.starttime_text || '--' }}</span>
						</template>
					</el-table-column>

					<el-table-column label="支付金额" width="120">
						<template slot-scope="{row}">
							<span class="text-bold">${{ row.amount }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="pay_model" label="支付方式" width="120" />
				</el-table>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentPage: 1,
				expirationTimeText: '',
				expirationTimestamp: 0,
				plans: [],
				upgradeVisible: false,
				rechargeDesc: '',
				rechargeVisible: false,
				currentSubscribe: null,
				walletMoney: '0.00',
				plansList: [],
				tableData: [],
				total: 0,

				pageSize: 10, // 默认每页10条
				dateRange: this.getDefaultDateRange(),
				selectedPlan: {}, // 当前选中的版本对象
				currentSeats: 1, // 当前选择的席位数量
				useBalance: true,
				rechargeForm: {
					amount: '',
					proof: '',
					payAmount: '0.00',
					rawFile: null
				},
				freePlan: {
					name: "Free版(当前版本)",
					price: "0",
					desc: "满足个人基础聊天",
					type: "free",
					buttonText: "继续当前版本",
					buttonType: "primary",
					isCurrent: true,
					features: ["2个成员", "100个/月会话", "500次/月自动化"]
				},
				customPlan: {
					name: "定制版",
					price: "???",
					desc: "专业团队单独报价",
					type: "custom",
					buttonText: "联系我们",
					buttonType: "info",
					logos: true,
					features: ["全功能定制", "专属服务器", "SLA保障"]
				},
			};
		},
		created() {
			this.getUserSubscribe();
			this.fetchSubscribePlans();
			this.fetchOrderList();
		},
		computed: {
			addedSeats() {
				const baseSeats = parseInt(this.selectedPlan.seats || 0);
				const current = parseInt(this.currentSeats || 0);
				return current > baseSeats ? current - baseSeats : 0;
			},

			addedSeatsCost() {
				if (this.addedSeats <= 0) return '0.00';
				const unitPrice = parseFloat(this.selectedPlan.seats_price || 0);
				return (this.addedSeats * unitPrice).toFixed(2);
			},

			// 3. 套餐总金额 (版本费用 price + 新增席位费用)
			packageTotal() {
				if (!this.selectedPlan.price) return '0.00';
				const basePrice = parseFloat(this.selectedPlan.price);
				const extraPrice = parseFloat(this.addedSeatsCost);
				return (basePrice + extraPrice).toFixed(2);
			},
			currentDiscountRate() {
				const discount = parseFloat(this.selectedPlan.discount || 0);
				// 如果折扣字段为 0 或不存在，通常视为不打折（即 100%）
				return discount > 0 ? discount : 100;
			},

			// 最终需支付 = 总金额 * (折扣 / 100)
			finalPayPrice() {
				const total = parseFloat(this.packageTotal);
				const rate = this.currentDiscountRate;
				return (total * (rate / 100)).toFixed(2);
			},

			newDeadline() {
				const nowSeconds = Math.floor(Date.now() / 1000);
				const planDays = (this.selectedPlan && this.selectedPlan.period) ?
					parseInt(this.selectedPlan.period) : 0;
				const addSeconds = planDays * 24 * 3600;
				const baseTimestamp = this.expirationTimestamp > nowSeconds ?
					this.expirationTimestamp :
					nowSeconds;

				const finalTimestamp = baseTimestamp + addSeconds;

				// 3. 格式化
				const date = new Date(finalTimestamp * 1000);
				const y = date.getFullYear();
				const m = String(date.getMonth() + 1).padStart(2, '0');
				const d = String(date.getDate()).padStart(2, '0');
				const hh = String(date.getHours()).padStart(2, '0');
				const mm = String(date.getMinutes()).padStart(2, '0');
				const ss = String(date.getSeconds()).padStart(2, '0');

				return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
			}
		},
		watch: {
			dateRange(val) {
				console.log("用户切换了日期，新日期是：", val);
				this.currentPage = 1; // 筛选条件改变，回到第一页
				this.fetchOrderList();
			}
		},
		methods: {
			getDefaultDateRange() {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); // 减去7天

				// 格式化为 yyyy-MM-dd
				const formatDate = (date) => {
					const y = date.getFullYear();
					const m = String(date.getMonth() + 1).padStart(2, '0');
					const d = String(date.getDate()).padStart(2, '0');
					return `${y}${m}${d}`;
				};

				return [formatDate(start), formatDate(end)];
			},
			async fetchOrderList() {
				this.loading = true;
				try {
					let timeStr = '';
					if (this.dateRange && this.dateRange.length === 2) {
						timeStr = `${this.dateRange[0]}-${this.dateRange[1]}`;
					}

					const p = {
						page: this.currentPage,
						limit: this.pageSize,
						search_time: timeStr
					};
					const queryString = `page=${p.page}&limit=${p.limit}&search_time=${p.search_time}`;
					const url = `${this.$apis.getOrderList}?${queryString}`;

					// 3. 发送请求
					const res = await this.$axios.get(url);
					
					if (res.code === 1) {
						const list = Array.isArray(res.data) ? res.data : (res.data.rows || res.data.list || []);
						this.tableData = list;
						this.total = res.data.total !== undefined ? res.data.total : list.length;
					} else {
						this.$message.error(res.msg || "获取订单失败");
					}
				} catch (error) {
					console.error("加载订单列表出错:", error);
				}
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1; // 切换每页条数时重置到第一页
				this.fetchOrderList();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.fetchOrderList();
			},
			handleUpgradeClick(plan) {
				if (plan.type === 'free') {
					this.$message.info('您当前正在使用基础版本');
					return;
				}
				if (plan.type === 'custom') {
					this.$message.warning('定制版请联系客户经理进行线下报价');
					return;
				}
				this.openUpgradeDialog(plan);
			},
			async openUpgradeDialog(targetPlan = null) {
				this.upgradeVisible = true;
				try {
					const res = await this.$axios.get(this.$apis.getSubscribeList);
					if (res.code === 1) {
						this.plansList = res.data.list;
						if (targetPlan) {
							const found = this.plansList.find(item => item.id === targetPlan.id || item.name ===
								targetPlan.name);
							this.selectPlan(found || this.plansList[0]);
						} else {
							this.selectPlan(this.plansList[0]);
						}
					}
				} catch (e) {
					this.$message.error("获取套餐列表失败");
				}
			},
			selectPlan(plan) {
				console.log('当前选中的天数:', plan.period)
				this.selectedPlan = plan;
				this.currentSeats = plan.seats || 1;
			},
			async submitUpgrade() {
				if (!this.selectedPlan || !this.selectedPlan.id) {
					this.$message.warning("请先选择一个套餐版本");
					return;
				}
				const postData = {
					id: this.selectedPlan.id, // 套餐 ID
					seats: this.currentSeats
				};
				try {
					const res = await this.$axios.post(this.$apis.subscribe, postData);

					if (res.code === 1) {
						this.$message.success("订单提交成功！");
						this.upgradeVisible = false;
						this.getUserSubscribe();
					} else {
						this.$message.error(res.msg || "提交失败，请重试");
					}
				} catch (error) {
					console.error("提交订单出错:", error);
					this.$message.error("网络异常，提交失败");
				}
			},
			async getUserSubscribe() {
				try {
					const res = await this.$axios.get(this.$apis.getInfo);
					if (res.code === 1 && res.data) {
						this.walletMoney = res.data.money !== undefined ? res.data.money : '0.00';
						const expTime = res.data.expirationtime || (res.data.chat && res.data.chat.expirationtime);
						this.expirationTimestamp = parseInt(expTime || 0);

						console.log("核心调试 - 当前过期时间戳:", this.expirationTimestamp);

						const sub = res.data.subscribe;
						this.currentSubscribe = (sub && !Array.isArray(sub)) ? sub : null;
					}
				} catch (error) {
					console.error("获取信息失败", error);
				}
			},
			// --- 3. 充值相关 ---
			async getRechargeInfo() {
				try {
					const res = await this.$axios.get(this.$apis.getData);
					if (res.code === 1) {
						this.rechargeDesc = res.data.desc;
					}
				} catch (error) {
					console.error("加载充值说明失败", error);
				}
			},
			handleRecharge() {
				this.rechargeVisible = true;
				this.getRechargeInfo();
			},
			handleFileChange(file) {
				this.rechargeForm.rawFile = file.raw;
				this.rechargeForm.proof = URL.createObjectURL(file.raw);
			},
			handleUploadSuccess(res) {
				if (res.code === 1) {
					this.rechargeForm.proof = res.data.url;
					this.$message.success('凭证上传成功');
				} else {
					this.$message.error('上传失败：' + res.msg);
				}
			},
			async submitRecharge() {
				const formData = new FormData();
				formData.append('amount', this.rechargeForm.amount);
				try {
					const loading = this.$loading({
						text: '正在提交申请...'
					});
					const res = await this.$axios.post(this.$apis.submit, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					});
					loading.close();
					if (res.code === 1) {
						this.$message.success('支付凭证已提交，请等待后台审核');
						this.rechargeVisible = false;
						this.resetRechargeForm();
					} else {
						this.$message.error(res.msg || '提交失败');
					}
				} catch (error) {
					this.$message.error('网络错误，请稍后再试');
				}
			},
			resetRechargeForm() {
				this.rechargeForm = {
					amount: '',
					proof: '',
					payAmount: '0.00',
					rawFile: null
				};
			},


			async fetchSubscribePlans() {
				try {
					const res = await this.$axios.get(this.$apis.getSubscribeList);
					if (res.code === 1 && res.data.list) {
						const dynamicPlans = res.data.list.map(item => {
							return {
								...item,
								period: item.period,
								periodName: item.period_name,
								type: item.name.includes('Pro') ? 'pro' : 'max',
								buttonText: "升级套餐",
								buttonType: item.name.includes('Pro') ? 'primary' : 'warning',
							};
						});
						this.plans = [this.freePlan, ...dynamicPlans, this.customPlan];
					}
				} catch (error) {
					console.error("加载套餐失败", error);
				}
			},
		}
	};
</script>

<style lang="scss" scoped>
	.renew-link {
		// 基础形状
		padding: 4px 12px;
		border-radius: 20px;
		background: rgba(64, 158, 255, 0.1); // 浅淡的主色背景
		border: 1px solid rgba(64, 158, 255, 0.3);

		// 文字样式
		font-size: 13px;
		font-weight: 500;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

		&:hover {
			background: #409eff; // 鼠标悬浮变全色
			color: #fff !important;
			box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
			transform: translateY(-1px);
		}

		&:active {
			transform: translateY(0);
		}
	}

	.status-tag {
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 12px;
	}

	.status-pending {
		color: #f56c6c;
		background: #fef0f0;
		border: 1px solid #fde2e2;
	}

	.text-bold {
		font-weight: 600;
		color: #303133;
	}

	.summary-title {
		font-size: 14px;
		font-weight: 600;
		color: #303133;

		border-left: 4px solid #4165d7;
		padding-left: 8px;

		margin-top: 0;
		margin-bottom: 15px;

		line-height: 1;
		display: flex;
		align-items: center;
	}

	.summary-detail-box {
		background: #f0f2f5;
		padding: 12px;
		border-radius: 6px;
		margin: 10px 0;

		.summary-item {
			margin-bottom: 8px;
			font-size: 13px;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	.final-price {
		color: #ff4d4f;
		font-size: 28px;
		font-weight: bold;
	}

	.text-muted {
		color: #909399;
	}

	.upgrade-container {
		display: flex;
		gap: 30px;

		.upgrade-config {
			flex: 2;

			.version-selector {
				display: flex;
				gap: 15px;

				.version-card {
					border: 1px solid #dcdfe6;
					padding: 15px;
					border-radius: 8px;
					cursor: pointer;
					flex: 1;

					&.active {
						border-color: #409eff;
						background-color: #ecf5ff;
					}

					.name {
						font-weight: bold;
						margin-bottom: 5px;
					}
				}
			}

			.config-section {
				margin-bottom: 30px;
			}
		}

		.upgrade-summary {
			flex: 1;
			background: #f8f9fb;
			padding: 20px;
			border-radius: 8px;

			.summary-item {
				display: flex;
				justify-content: space-between;
				margin-bottom: 15px;
				font-size: 14px;
			}

			.total-row {
				margin-top: 10px;

				.final-price {
					color: #f56c6c;
					font-size: 24px;
					font-weight: bold;
				}
			}

			.submit-btn {
				width: 100%;
				margin-top: 20px;
			}
		}
	}

	.pay-amount-value {
		color: #ff9800;
	}

	.recharge-desc-content {
		background-color: #fffbef;
		padding: 15px;
		border-radius: 4px;
		color: #ff9800;
		font-size: 13px;
		line-height: 1.6;
		margin-left: -100px;
		width: calc(100% + 100px);
		box-sizing: border-box;

		::v-deep ul {
			margin: 0;
			list-style: none !important;

		}

		::v-deep li {
			margin-bottom: 8px;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	::v-deep .el-upload--picture-card {
		width: 100px !important;
		height: 100px !important;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;

		}
	}

	// 变量定义
	$c-primary: #4165d7;
	$c-warning: #ff9800;
	$c-text-main: #303133;
	$c-text-sub: #909399;
	$border-color: #ebeef5;

	::v-deep .el-table__header-wrapper {
		border: 1px solid #ebeef5;
		border-bottom: none;
	}

	::v-deep .el-table__body-wrapper {
		border-left: 1px solid #ebeef5;
		border-right: 1px solid #ebeef5;
	}


	.version-page {


		.card-header {
			font-size: 16px;
			font-weight: 600;
			color: $c-text-main;
			border-left: 4px solid $c-primary;
			padding-left: 12px;
			margin-bottom: 20px;

			&.flex-between {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
		}


		.overview-section {
			background: #fff;
			padding: 24px;
			border-radius: 8px;
			margin-bottom: 24px;

			.status-grid {
				display: flex;

				.status-item {
					flex: 1;
					text-align: center;
					border-right: 1px solid #eee;

					&:last-child {
						border-right: none;
					}

					.label {
						color: $c-text-sub;
						font-size: 14px;
						margin-bottom: 12px;
					}

					.price {
						font-size: 26px;
						font-weight: bold;
						color: $c-text-main;
					}

					.value {
						font-size: 20px;
						font-weight: 600;
					}
				}
			}
		}

		// 2. 套餐卡片布局
		.plan-grid {
			display: flex;
			gap: 20px;
			margin-bottom: 30px;
			overflow-x: auto;
			padding-bottom: 10px;

			.plan-card {
				position: relative;
				background: #fff;
				border-radius: 12px;
				padding: 32px 24px;
				min-width: 280px;
				flex: 1;
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				border-top: 4px solid #eee;

				// &:hover {
				//   transform: translateY(-8px);
				//   box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
				// }

				&.free {
					border-top-color: #909399;
				}

				&.pro {
					border-top-color: $c-primary;
				}

				&.max {
					border-top-color: $c-warning;
				}

				&.custom {
					border-top-color: #607d8b;
				}

				.discount-tag {
					position: absolute;
					top: 0;
					right: 20px;
					background: #f56c6c;
					color: #fff;
					padding: 4px 8px;
					border-radius: 0 0 4px 4px;
					font-size: 12px;
				}

				.price-box {
					margin: 20px 0;

					.amount {
						font-size: 36px;
						font-weight: 800;
						color: $c-text-main;
					}

					.unit {
						font-size: 20px;
						font-weight: 600;
						margin-right: 4px;
					}
				}

				.desc {
					font-size: 13px;
					color: $c-text-sub;
					min-height: 40px;
					margin-bottom: 20px;
				}

				.plan-btn {
					width: 100%;
					margin-bottom: 24px;
					height: 42px;
					font-size: 15px;
				}

				.feature-list {
					list-style: none;
					padding: 0;

					li {
						font-size: 13px;
						margin-bottom: 14px;
						display: flex;
						align-items: flex-start;

						i {
							color: #67c23a;
							margin-right: 8px;
							margin-top: 2px;
						}
					}
				}
			}
		}

		// 3. 订单列表
		.order-section {
			background: #fff;
			padding: 24px;
			border-radius: 8px;

			.filter-box {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 20px;

				.filter-label {
					font-size: 14px;
					font-weight: normal;
					color: $c-text-sub;
				}
			}

			.status-pending {
				color: #f56c6c;
				background: #fef0f0;
				padding: 2px 8px;
				border-radius: 4px;
			}

			.pagination-container {
				display: flex;
				justify-content: flex-end;
			}
		}
	}

	// 常用辅助类
	.ml-10 {
		margin-left: 10px;
	}

	.ml-20 {
		margin-left: 20px;
	}

	.text-bold {
		font-weight: 600;
	}

	.text-muted {
		color: #ccc;
	}
</style>